var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gt-list-tree-option",style:({ paddingLeft: _vm.depth * 1.25 + 'rem' })},[(_vm.depth)?_c('span',{staticClass:"gt-list-tree-option__branch"},[_vm._v("└")]):_vm._e(),_c('span',{class:{ 'fw-semibold': _vm.hasChildren }},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }